import { AxiosResponse } from 'axios'
import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'
import { RequestREAD } from 'services/Instances'

export function ReportsAcessServices() {
  const path = 'RelatorioAcesso'

  const getCards = async (request: RequestGet): Promise<AxiosResponse> =>
    await RequestREAD.post(path + '/Cards', request)

  const getContrato = async (
    request: RequestGetVisualizar
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(path + '/Contrato', request)
  const getFornecedor = async (
    request: RequestGetVisualizar
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(path + '/Fornecedor', request)
  const getContratoExcel = async (
    request: RequestGetVisualizar
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(path + '/Contrato/RelatorioExcel', request)
  const getFornecedorExcel = async (
    request: RequestGetVisualizar
  ): Promise<AxiosResponse> =>
    await RequestREAD.post(path + '/Fornecedor/RelatorioExcel', request)

  return {
    getCards,
    getContrato,
    getContratoExcel,
    getFornecedor,
    getFornecedorExcel
  }
}
export interface RequestGet {
  cdContrato?: string
  dataInicio?: Date
  dataFim?: Date
  nomeContraparte?: string
  nomeEmpresa?: string
  nomeCentro?: string
  nomeFornecedor?: string
  unidadeGestoraId?: IOnChangeUnidadeGestora
  empresasIds?: number[]
  centrosIds?: number[]
  fornecedoresIds?: number[]
  subcontratadasIds?: number[]
  contratosIds?: number[]
  perfil?: number
  status?: string
  nomeSubcontratada?: string
}

export interface RequestGetVisualizar {
  unidadeGestoraId: number
  flStatus: string
  dataIni?: Date
  dataFim?: Date
  perfil: string
  empresasIds: number[]
  centrosIds: number[]
  contratosIds?: number[]
  fornecedoresIds?: number[]
  subcontratadasIds?: number[]
}
